export const IS_DEV = process.env.NODE_ENV === "development";

export const DADATA_API_KEY = "e48e8276d13ee3655cc6a19a32ef8fc846b5c462";

export const $DOCUMENT = $(document);
export const $WINDOW = $(window);
export const $BODY = $("body");
export const $TOPLINE = $(".js-topline");
export const $CARDS_WITH_MODAL = $(".js-card-modal");
export const $LOCAL_MENU = $(".js-topline-nav:first");

export const BTN_PRIMARY_CLASS = "btn--primary";
export const BTN_SECONDARY_CLASS = "btn--secondary";

export const ACTIVE_CLASS = "active";
export const Z_INDEX_CLASS = "z-index";
export const SHOW_CLASS = "show";
export const HIDDEN_CLASS = "hide";
export const CLICKED_CLASS = "clicked";
export const DISABLE_CLASS = "disable";
export const YA_POPUP_CLASS = "ya-popup";
export const ERROR_CLASS = "error";

export const SCROLL_CLASS = "scroll";
export const CURRENT_CLASS = "current";
export const RANGE_CLASS = "range";
export const BORDER_BOTTOM_CLASS = "border-bottom";
export const OVERFLOW_HIDDEN_CLASS = "overflow";

export const DIRECTIONS_MENU_CLASS = "directions";
export const LOCAL_SITE_MENU_CLASS = "local";

export const BODY_LOCK_CLASS = "body-lock";

export const L_MOBILE_WIDTH = 640;
export const MOBILE_WIDTH = 768;
export const TABLET_WIDTH = 1024;
export const L_TABLET_WIDTH = 1200;
export const XL_TABLET_WIDTH = 1240;
export const S_DESKTOP_WIDTH = 1320;

export default $DOCUMENT;
